import { SVGProps } from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export function ReloadIcon(props: IconProps) {
  return <Icon as={ReloadIconComponent} color="purple.500" boxSize="20px" {...props} />;
}

function ReloadIconComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="20" height="20" rx="10" fill="currentColor" />
      <path
        d="M8.00074 6.53613C6.08759 7.64069 5.43207 10.0871 6.53664 12.0002C7.6412 13.9134 10.0876 14.5689 12.0007 13.4643C13.9139 12.3598 14.5694 9.91339 13.4648 8.00023L12.772 8.40023C13.6557 9.93078 13.1313 11.8879 11.6007 12.7715C10.0702 13.6552 8.11312 13.1308 7.22946 11.6002C6.3458 10.0697 6.8702 8.11261 8.40074 7.22895C9.25425 6.73618 10.2404 6.68128 11.0991 6.99455L10.7864 8.161L12.8648 6.961L11.6648 4.88254L11.3066 6.21934C10.2492 5.85463 9.04548 5.93295 8.00074 6.53613Z"
        fill="white"
      />
    </svg>

  );
}
